const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

class APIService {
  constructor() {
    this.token = localStorage.getItem('admin_token');
  }

  // Helper method to make API calls
  async makeRequest(endpoint, options = {}) {
    const url = `${BASE_URL}${endpoint}`;

    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...(this.token && { 'Authorization': `Bearer ${this.token}` })
      }
    };

    const finalOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers
      }
    };

    try {
      const response = await fetch(url, finalOptions);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'API request failed');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Authentication methods
  async login(username, password) {
    const response = await this.makeRequest('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password })
    });

    if (response.success) {
      this.token = response.token;
      localStorage.setItem('admin_token', response.token);
    }

    return response;
  }

  async verifyToken() {
    if (!this.token) return { valid: false };

    try {
      const response = await this.makeRequest('/auth/verify', {
        method: 'POST',
        body: JSON.stringify({ token: this.token })
      });
      return response;
    } catch (error) {
      return { valid: false };
    }
  }

  logout() {
    this.token = null;
    localStorage.removeItem('admin_token');
  }

  // Tender methods
  async searchTenders(keyword) {
    return await this.makeRequest('/tender/search', {
      method: 'POST',
      body: JSON.stringify({ keyword })
    });
  }

  async uploadTender(tenderId) {
    return await this.makeRequest('/tender/upload', {
      method: 'POST',
      body: JSON.stringify({ tender_id: tenderId })
    });
  }

  async startDownload(tender) {
    // Pass the full tender object including detail_url
    return await this.makeRequest(`/tender/${tender.id}/start-download`, {
      method: 'POST',
      body: JSON.stringify({
        tender_id: tender.id,
        reference_no: tender.reference_no,
        detail_url: tender.detail_url,
        title: tender.title
      })
    });
  }

  async submitCaptcha(tenderId, captchaText) {
    return await this.makeRequest(`/tender/${tenderId}/submit-captcha`, {
      method: 'POST',
      body: JSON.stringify({ captcha_text: captchaText })
    });
  }

  async getStatus() {
    return await this.makeRequest('/tender/status');
  }

  // Health check
  async healthCheck() {
    return await this.makeRequest('/health');
  }


  async listFirebaseTenders() {
    return await this.makeRequest('/tender/list');
  }

  async deleteTender(tenderId) {
    return await this.makeRequest(`/tender/${tenderId}`, {
      method: 'DELETE'
    });
  }

}

// Create and export a single instance
const apiService = new APIService();
export default apiService;
